import { StyleSheet, View, ViewProps } from 'react-native'
import type { NormalizedCompanyColorScheme } from 'zens-store'
import { Color, Spacing, Text } from 'zens-storybook'
import { Trans } from 'react-i18next'

import { FloorplanDesk } from '../floorplan'

import { legendItemsFromColorScheme } from './colorscheme'

const styles = StyleSheet.create({
  container: {
    position: 'absolute',
    bottom: Spacing.M,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    marginVertical: Spacing.XS,
  },
  text: {
    marginLeft: Spacing.S,
    letterSpacing: 2,
  },
})

interface Props extends ViewProps {
  colorScheme: NormalizedCompanyColorScheme
}

const InsightsLiveKioskFooter = (props: Props) => {
  const { colorScheme, style, ...otherProps } = props
  const legendItems = legendItemsFromColorScheme(colorScheme)

  return (
    <View style={[styles.container, style]} {...otherProps}>
      {legendItems.map((item) => (
        <View style={styles.row} key={item.key}>
          <FloorplanDesk color={item.color} />
          <Text style={styles.text}>
            <Trans>{item.label}</Trans>
          </Text>
        </View>
      ))}
      <View style={styles.row}>
        <FloorplanDesk color={Color.calmGrey} />
        <Text style={styles.text}>
          <Trans>Unknown</Trans>
        </Text>
      </View>
    </View>
  )
}

export default InsightsLiveKioskFooter
